import { render, staticRenderFns } from "./TransactionTypeForm.vue?vue&type=template&id=65af16b8&scoped=true&"
import script from "./TransactionTypeForm.vue?vue&type=script&lang=js&"
export * from "./TransactionTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af16b8",
  null
  
)

export default component.exports